import Swiper, { Navigation, Controller, EffectFade, Mousewheel } from 'swiper';

const classes = {
  swipeableCarousel: 'is-swipeable-carousel',
  wrapperCenter: 'swiper-wrapper--center',
};

const imageReviewCarousel = () => ({
  /**
   * Applies conditional classes if swiper is scrollable or not
   * @param {Swiper} swiper - Swiper instance
   * @param {Object} alpine - Alpine JS instance
   * @param {String} rootClass - Class to toggle on the root element
   */
  swiperCenterOnNoScroll: (swiper, alpine, rootClass) => {
    const isSwipeable = swiper.virtualSize > swiper.size;
    if (isSwipeable) {
      if (rootClass) alpine.$root?.classList.add(rootClass);
      swiper.wrapperEl?.classList.remove(classes.wrapperCenter);
    } else {
      if (rootClass) alpine.$root?.classList.remove(rootClass);
      swiper.wrapperEl?.classList.add(classes.wrapperCenter);
    }
  },

  get swiperReviewConfig() {
    return {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      followFinger: false,
      modules: [Navigation, Controller, EffectFade, Mousewheel],
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      loop: true,
      loopedSlides: 30,
      centeredSlides: true,
    };
  },

  get swiperImageConfig() {
    return {
      slidesPerView: 'auto',
      modules: [Controller, Mousewheel],
      mousewheel: {
        forceToAxis: true,
      },
      grabCursor: true,
      loop: true,
      loopedSlides: 30,
      centeredSlides: true,
      on: {
        init: (swiper) =>
          this.swiperCenterOnNoScroll(swiper, this, classes.swipeableCarousel),
        resize: (swiper) =>
          this.swiperCenterOnNoScroll(swiper, this, classes.swipeableCarousel),
        click(swiper) {
          swiper.slideTo(this.clickedIndex);
        },
      },
    };
  },

  buildSwipers() {
    this.reviewSwiperInstance = new Swiper(
      this.$refs.reviewSwiper,
      this.swiperReviewConfig
    );
    this.imageSwiperInstance = new Swiper(
      this.$refs.imageSwiper,
      this.swiperImageConfig
    );

    // Sync carousels so they scroll in unison
    this.reviewSwiperInstance.controller.control = this.imageSwiperInstance;
    this.imageSwiperInstance.controller.control = this.reviewSwiperInstance;
  },

  init() {
    this.buildSwipers();
  },
});

export default imageReviewCarousel;
